import React from "react";

const QS = () => {
  return <div>QS</div>;
};

export default QS;
